import { createFileRoute, redirect } from "@tanstack/react-router";
import { waitingOnYouSearch } from "./waiting-on-you";

/**
 * The access-decision queue's former address (Jira NAV-111).
 *
 * The decisions are a tab of "Waiting on you" now, and this address arrives on
 * it. Nothing mints this link any more — the mail about a routed request has
 * always pointed at `/end-user/decisions/{id}`, the single request, which is a
 * different route and is untouched — but the address has been in the navigation
 * and in people's bookmarks, so it keeps resolving.
 *
 * The tab is named rather than left to the destination's default: this address
 * meant the decisions, and the default is the other tab.
 */
export const Route = createFileRoute("/end-user/decisions")({
  validateSearch: waitingOnYouSearch,
  beforeLoad: ({ search }) => {
    throw redirect({
      to: "/end-user/waiting-on-you",
      search: { ...search, tab: "decisions" },
      replace: true,
    });
  },
});
